import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Header from "./../../components/rfq/header/header";
import PartInformation from "./../../components/rfq/partInformation/partInformation";
import ContactForm from "./../../components/rfq/contactForm/contactForm";
import Menu from "./../../components/home/menu/menu";
import Footer from "./../../components/home/footer/footer";

const Rfq = () => {
    const location = useLocation();
    const partInfoRef = useRef(null);

    useEffect(() => {
        // Check if location state has a scrollToPartInformation flag
        if (location.state?.scrollToPartInformation && partInfoRef.current) {
            partInfoRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);

    return (
        <div>
            <div className='menuColor1'><Menu /></div>
            <div><Header /></div>
            <div ref={partInfoRef}><PartInformation /></div>
            <div><ContactForm /></div>
            <div className='Footer'>
                <Footer />
            </div>
        </div>
    );
}

export default Rfq;
